// Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved.
import { GeneLink } from '../../interfaces/hce/hce-sv';

export function makeGenesNameLinks(
    genes?: string[],
    genes_hrefs?: string[]
): GeneLink[] {
    const out: GeneLink[] = [];
    if (!genes?.length) return out;
    for (let i = 0; i < genes.length; i++) {
        out.push({ name: genes[i], id: genes_hrefs?.[i] ?? '' });
    }
    return out;
}